import HeaderBack from '@/components/HeaderBack/HeaderBack';
import Picker from '@/components/Picker/Picker';
import { devServerApi } from '@/shared/apis/devServerApi';
import { useModalStore } from '@/stores/common/useModalStore';
import { useNavigate } from 'react-router-dom';
import { usePolicyStore } from '@/stores/common/usePolicyStore';
import { useLayoutStore } from '@/stores/common/useLayoutStore';

const dayList = [7, 14, 30, 60, 90];

const AvailableReservation = () => {
  const navigate = useNavigate();
  const { bookingAvailableDays, setBookingAvailableDays } = usePolicyStore();
  const { setMenuModal } = useModalStore();
  const { setSpinner } = useLayoutStore();

  const handleOnPickerSuccess = async (selected) => {
    const V = selected.leftArea;
    await setSpinner(true);
    await devServerApi.api.patch('/policy/reservations', { bookingAvailableDays: V });
    await setSpinner(false);
    setBookingAvailableDays(V);
  };
  return (
    <>
      <HeaderBack inBack={true} isCenter>
        <div className="font__heading_4">예약 신청 가능 기간</div>
      </HeaderBack>
      <section className="settings-policy-detail-wrapper">
        <div className="switch-area pointer" onClick={() => setMenuModal({ visible: true, key: 'available-reservation-picker-modal' })}>
          <div className="left-area">
            <div className="font__title_20_b">
              예약 신청 <br /> 가능 기간
            </div>
            <div className="font__body_5 keep-all">
              오늘부터 며칠 후까지 <br />
              예약을 열어둘까요?
            </div>
          </div>
          <div className="right-area gap-16">
            <div className="font__heading_4">{bookingAvailableDays}일 후까지</div>
          </div>
        </div>
      </section>
      <Picker
        title="예약 신청 가능 기간"
        tabletCustomInformationMessage="오늘부터 며칠 후까지 예약을 열어둘까요?"
        modalKey="available-reservation-picker-modal"
        // visible={visibleModal}
        leftArea={{ list: dayList, unit: '일', selected: bookingAvailableDays }}
        onSuccess={handleOnPickerSuccess}
        onSuccessText="완료"
      />
    </>
  );
};

export default AvailableReservation;
